import PropTypes from 'prop-types'
import React from 'react'
import {
  debounce,
  platformTransitionStyle,
} from '../../../../shared/helpers.js'
import focusable from '../../components/Focusable/Focusable'
import tts from '../../lib/TTS'
import Modal from '../Modal/Modal'

const scrollInterval = 100

class ScrollingTextModal extends React.Component {
  static defaultProps = {
    title: '',
    content: '',
  }
  constructor(props) {
    super(props)

    this.content = null
    this.componentType = props.componentType
    this.contentHeight = 0
    this.delta = 0

    this.state = {
      offset: 0,
    }
  }

  onKeyEvent(key) {
    let handled = false

    if ('DOWN' === key || 'UP' === key) {
      this.debounced_divScroll(key)
      handled = true
    }
    if ('LEFT' === key || 'RIGHT' === key) {
      //put this here to prevent the loss of focus to the non-existent side panel
      //prevent bubbling the event up.
      handled = true
    }

    return handled
  }

  debounced_divScroll = debounce(this.divScroll, 50)

  divScroll(dir) {
    this.contentHeight = this.content.scrollHeight - this.content.offsetHeight

    let offset = this.state.offset
    if ('DOWN' === dir) {
      //if the offset is greater or equal to the content height we are at the bottom of the text; exit
      if (this.state.offset >= this.contentHeight) {
        return
      } else {
        offset += scrollInterval
        //scroll down
        this.setState({ offset })
      }
    } else if ('UP' === dir) {
      //if the delta is greater than or equal to the content height we are back to the top of the text; exit
      if (this.delta >= this.contentHeight) {
        return
      } else {
        offset -= scrollInterval
        //scroll up
        this.setState({ offset })
      }
    }
    this.delta = Number(this.contentHeight - this.offset)
  }

  readText() {
    tts.addTextToRead([this.props.title, this.props.content])
  }

  render() {
    const { componentType, title, content, visible, hideStationLogo, center } =
      this.props

    return (
      <section className={`scrolling-text-modal ${visible ? 'visible' : ''}`}>
        <Modal componentType={componentType} hideStationLogo={hideStationLogo}>
          <h1
            className={`title ${
              componentType === 'descriptionModal' ? 'description-modal' : ''
            } ${center ? 'center' : ''}`}
          >
            {title}
          </h1>
          <div className="scroll-hide">
            <div
              className="content"
              style={{
                transition: platformTransitionStyle(
                  'transform 500ms ease-in-out'
                ),
                transform: `translate(0, -${this.state.offset}px)`,
              }}
            >
              {content}
            </div>
          </div>
          {this.props.children}
        </Modal>
      </section>
    )
  }
}

ScrollingTextModal.propTypes = {
  center: PropTypes.bool,
  children: PropTypes.element,
  componentType: PropTypes.string,
  content: PropTypes.string,
  hideStationLogo: PropTypes.bool,
  title: PropTypes.string,
  visible: PropTypes.bool,
}

export default focusable(ScrollingTextModal)
